import React from "react";
import { ProjectLinkSurveyProcessingModalStyle as S } from "./ProjectLinkSurveyProcessingModal.style";
import { PButton } from "@prime/PButton/PButton";
import { Link } from "react-router-dom";
import { useHasPolicy } from "hooks/useHasPolicy";
import { useObservable } from "@rsm";
import { getClientService } from "services/client.service";

export const ProjectLinkSurveyProcessingModal: React.FC<{
  projectId: number;
  statusCode: number;
  teamId?: number;
  setVisible: (visible: boolean) => void;
}> = ({ projectId, statusCode, teamId, setVisible }) => {
  const isSuperAdmin = useHasPolicy("IdeallyAdmin");
  const clientIdCur = useObservable(getClientService().defaultClientId$);

  return (
    <S.ProjectLinkSurveyProcessingModal onHide={() => setVisible(false)} showHeader={false}>
      <h4>Survey in progress</h4>
      <div className="mb-5">
        Sit tight, results will be available soon. It can take up to 24 hours to gather and analyze results.
      </div>
      <br />
      {isSuperAdmin && statusCode > 200 ? (
        <Link className="mt-5 ml-auto" to={`/${teamId ?? clientIdCur}/results/${projectId}`}>
          Super admin, view result
        </Link>
      ) : isSuperAdmin ? (
        <Link className="mt-5 ml-auto" to={`/${teamId ?? clientIdCur}/project/${projectId}`}>
          Super admin, view test setup
        </Link>
      ) : null}
      <PButton label="Ok, close" className="mt-5 ml-auto" onClick={() => setVisible(false)} />
    </S.ProjectLinkSurveyProcessingModal>
  );
};
